<template>
  <div class="month-days-selector-container" @mouseenter="expand(true)" @mouseleave="expand(false)">
    <div class="expanded-container" v-if="expanded">
      <span
        class="cell day"
        v-for="day in days"
        :key="day"
        :class="{
          highlighted: isHighlighted(day)
        }"
        @click="clicked(day)"
        >{{ day + 1 }}</span
      >
    </div>
    <div class="not-expanded-container" v-else>
      <span class="days-title">{{ anyHighlighted ? "Числа месяца:" : "Не выбрано чисел месяца" }}</span>
      <span class="day" v-for="day in highlighted" :key="day">{{ day + 1 }}</span>
    </div>
  </div>
</template>
<script>
import { removeElementFromArray } from "@/common/utils.array";
export default {
  props: {
    /** задержка в мс прежде чем показать или скрыть */
    delay: {
      type: Number,
      default: 300
    },
    highlighted: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    anyHighlighted() {
      return this.highlighted && this.highlighted.length;
    }
  },
  data() {
    return {
      //highlighted: [],
      expanded: false,
      isMouseOver: false,
      days: Array(31)
        .fill(0)
        .map((e, i) => i)
    };
  },
  methods: {
    expand(value) {
      if (this.isMouseOver == value) return;
      this.isMouseOver = value;

      if (this.expanded == value) return;
      if (this.delay > 0) {
        setTimeout(() => {
          if (this.isMouseOver == value) {
            this.expanded = value;
          }
        }, this.delay);
      } else {
        this.expanded = value;
      }
    },
    clicked(day) {
      const isRemoved = removeElementFromArray(this.highlighted, day);
      if (!isRemoved) {
        this.highlighted.push(day);
        this.highlighted.sort((a, b) => a - b);
      }

      this.$emit("highlighedChanged", {
        day: day,
        highlighted: !isRemoved
      });
    },
    isHighlighted(day) {
      if (!this.anyHighlighted) return false;

      return this.highlighted.includes(day);
    }
  }
};
</script>
<style lang="postcss">
.month-days-selector-container {
  .expanded-container {
    z-index: 100;

    width: 300px;
    border: 1px solid #ccc;

    .cell {
      display: inline-block;
      padding: 0 5px;
      width: calc(100% / 7);
      height: 40px;
      line-height: 40px;
      text-align: center;
      vertical-align: middle;
      border: 1px solid transparent;

      &:not(.blank):not(.disabled).day {
        cursor: pointer;
        &:hover {
          border: 1px solid #4bd;
        }
      }
      &.highlighted {
        background: var(--bg-active);
      }
    }
  }
  .not-expanded-container {
    .day {
      padding: 0 3px;
    }
  }
}
</style>
